import { Typography } from "@/components/Atoms";

const AccordionHeader = ({ title, Icon, withPing = false }) => (
  <div className='w-full justify-between flex pr-2'>
    <Typography size='s16ToS12' className='text-[#979797] lg:text-[11px]' isBold>
      {title}
    </Typography>
    <div className='flex flex-row items-center'>
      {withPing && (
        <div className='z-10 my-1 flex justify-center items-center overflow-hidden rounded-full'>
          <span className='relative flex h-5 w-5'>
            <span
              className='absolute inline-flex h-full w-full rounded-full bg-[#12DB00] opacity-75 animate-ping'
              style={{ animationDuration: '2s' }}
            ></span>
            <span className='relative inline-flex rounded-full h-3 w-3 bg-[#12DB00] m-auto'></span>
          </span>
        </div>
      )}
      <Icon />
    </div>
  </div>
);
export default AccordionHeader;
